<div class="row g-3 market-section">
  <div class="col-lg-8 col-md-12 col-sm-12">
    <div class="market-left-column">
      <div class="comparison-card">
        <div class="comparison-columns">
          <div class="comparison-column">
            <span class="comparison-label">{{ 'home.your_portfolio' | translate }}</span>
            @if (isLoadingPortfolioVsMarketComparison()) {
              <p-skeleton height="24px" width="60px" />
            } @else if (comparisonDisplayData(); as data) {
              <span
                class="comparison-percentage"
                [class.positive]="data.portfolioPercent >= 0"
                [class.negative]="data.portfolioPercent < 0"
              >
                {{ data.portfolioPercent | number: '1.2-2' }}%
                @if (data.portfolioPercent > 0) {
                  <i class="pi pi-arrow-up-right" aria-hidden="true"></i>
                } @else if (data.portfolioPercent < 0) {
                  <i class="pi pi-arrow-down-left" aria-hidden="true"></i>
                }
              </span>
            } @else {
              <span class="comparison-placeholder">—</span>
            }
          </div>
          <div class="comparison-column">
            <span class="comparison-label">{{ 'home.tasi' | translate }}</span>
            @if (isLoadingPortfolioVsMarketComparison()) {
              <p-skeleton height="24px" width="60px" />
            } @else if (comparisonDisplayData(); as data) {
              <span
                class="comparison-percentage"
                [class.positive]="data.tasiPercent >= 0"
                [class.negative]="data.tasiPercent < 0"
              >
                {{ data.tasiPercent | number: '1.2-2' }}%
                @if (data.tasiPercent > 0) {
                  <i class="pi pi-arrow-up-right" aria-hidden="true"></i>
                } @else if (data.tasiPercent < 0) {
                  <i class="pi pi-arrow-down-left" aria-hidden="true"></i>
                }
              </span>
            } @else {
              <span class="comparison-placeholder">—</span>
            }
          </div>
          <div class="comparison-column comparison-column-note">
            @if (isLoadingPortfolioVsMarketComparison()) {
              <p-skeleton height="24px" width="100%" />
            } @else {
              <span class="comparison-note">
                {{ comparisonNote().key | translate: comparisonNote().params ?? {} }}
              </span>
            }
          </div>
        </div>
      </div>
      <div class="tasi-index-mobile-section">
        <div class="tasi-minimal-stats">
          <h6
            class="header-title mb-0 d-flex align-items-center gap-2 cursor-pointer"
            [routerLink]="['/market-summary']"
            (click)="onMarketIndexExpand()"
          >
            {{ 'home.market_summary' | translate }}
            <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center" aria-hidden="true"></i>
          </h6>
          @if (isLoadingTasiMinimal()) {
            <p-skeleton height="24px" width="80px" />
            <p-skeleton height="24px" width="100px" />
          } @else {
            <span class="tasi-minimal-price">{{ tasiMinimalLastPrice() ?? 0 }}</span>
            <span
              class="tasi-minimal-change"
              [class.positive]="(tasiMinimalLastPriceChangePercent() ?? 0) >= 0"
              [class.negative]="(tasiMinimalLastPriceChangePercent() ?? 0) < 0"
            >
              {{ tasiMinimalLastPriceChange() ?? 0 }}
              ({{ tasiMinimalLastPriceChangePercent() ?? 0 }}%)
              @if ((tasiMinimalLastPriceChangePercent() ?? 0) > 0) {
                <i class="pi pi-arrow-up-right" aria-hidden="true"></i>
              } @else if ((tasiMinimalLastPriceChangePercent() ?? 0) < 0) {
                <i class="pi pi-arrow-down-left" aria-hidden="true"></i>
              }
            </span>
          }
        </div>
        <div class="tasi-minimal-chart">
          @if (isLoadingTasiMinimal()) {
            <p-skeleton height="80px" width="100%" />
          } @else {
            <mohlel-mini-line-chart [data]="tasiMinimalData()" [color]="tasiMinimalChartColor()" />
          }
        </div>
      </div>
      <div class="stockdio-section">
        <div class="header-section">
          <h5 class="header-title mb-0">{{ 'home.page-name' | translate }}</h5>
          <span class="market-tag">{{ 'home.tasi' | translate }}</span>
          @if (isMarketOpenToday() !== null) {
            <span
              class="market-state-badge"
              [class.market-state-open]="isMarketOpenToday() === true"
              [class.market-state-closed]="isMarketOpenToday() === false"
            >
              @switch (isMarketOpenToday()) {
                @case (true) {
                  {{ 'home.market_open' | translate }}
                }
                @case (false) {
                  {{ 'home.market_closed' | translate }}
                }
              }
            </span>
          }
        </div>
        <mohlel-stock-chart-panel
          [chartHeight]="'200px'"
          [isLoading]="isLoadingMarketChart()"
          [data]="marketChartData()"
          [chartResponse]="marketChartResponse()"
          [selectedPeriod]="selectedMarketPeriod()"
          (periodChange)="onMarketFilterClick($event)"
        />
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-12 col-sm-12">
    <div class="blogs-section">
      <a [routerLink]="['/news']" class="header-title blogs-header-link">
        <h5 class="mb-0">{{ 'home.blog-section' | translate }}</h5>
        @if (isRtl()) {
          <i class="pi pi-chevron-left" aria-hidden="true"></i>
        } @else {
          <i class="pi pi-chevron-right" aria-hidden="true"></i>
        }
      </a>
      <div class="blogs-list">
        @if (isLoadingNews()) {
          <p-skeleton height="100%" width="100%" />
        } @else {
          @for (blog of news; track blog.id) {
            <mohlel-news-card
              [routerLink]="['/news', blog.id, blog.title]"
              [news]="blog"
              (click)="onNewsArticleClick(blog.id)"
            />
          }
        }
      </div>
    </div>
  </div>
</div>
<div class="row statistics-section pt-3 g-3">
  <div class="col-lg-8 col-md-12 col-sm-12">
    <div class="chart-wrapper">
      <!-- Desktop: Bootstrap grid -->
      <div class="desktop-grid row g-2">
        <div class="col-md-4 col-sm-12">
          <div class="content">
            <h5 class="header-title">
              {{ 'home.bar-chart-1' | translate }}
              <mohlel-info-tooltip
                class="mx-2"
                [content]="'home.bar-chart-tooltip-eps' | translate"
                [metricName]="'eps'"
              />
            </h5>
            @if (isLoadingStatisticsChart()) {
              <p-skeleton height="400px" width="100%" />
            } @else {
              @for (stock of stocksEps; track stock.id) {
                <div class="stock-item" (click)="navigateToStock(stock.id)">
                  <p-avatar shape="circle">
                    <img [src]="stock.imageUrl" [alt]="stock.name" />
                  </p-avatar>

                  <div class="content-wrapper">
                    <div class="text-wrapper">
                      <span class="name">{{ stock.name }}</span>
                      <span class="value">{{ stock.value }}</span>
                    </div>
                    <div>
                      <p-progressBar
                        class="custom-progressBar"
                        [value]="stock.percentage"
                        [showValue]="false"
                      />
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="content">
            <h5 class="header-title">
              {{ 'home.bar-chart-2' | translate }}
              <mohlel-info-tooltip
                class="mx-2"
                [content]="'home.bar-chart-tooltip-pe' | translate"
                [metricName]="'trailing_pe'"
              />
            </h5>
            @if (isLoadingStatisticsChart()) {
              <p-skeleton height="400px" width="100%" />
            } @else {
              @for (stock of stocksTrailingPe; track stock.id) {
                <div class="stock-item" (click)="navigateToStock(stock.id)">
                  <p-avatar shape="circle">
                    <img [src]="stock.imageUrl" [alt]="stock.name" />
                  </p-avatar>

                  <div class="content-wrapper">
                    <div class="text-wrapper">
                      <span class="name">{{ stock.name }}</span>
                      <span class="value">{{ stock.value }}</span>
                    </div>
                    <div>
                      <p-progressBar
                        class="custom-progressBar"
                        [value]="stock.percentage"
                        [showValue]="false"
                      />
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="content">
            <h5 class="header-title">
              {{ 'home.bar-chart-3' | translate }}
              <mohlel-info-tooltip
                class="mx-2"
                [content]="'home.bar-chart-tooltip-market-cap' | translate"
                [metricName]="'market_cap'"
              />
            </h5>
            @if (isLoadingStatisticsChart()) {
              <p-skeleton height="400px" width="100%" />
            } @else {
              @for (stock of stocksMarketCap; track stock.id) {
                <div class="stock-item" (click)="navigateToStock(stock.id)">
                  <p-avatar shape="circle">
                    <img [src]="stock.imageUrl" [alt]="stock.name" />
                  </p-avatar>

                  <div class="content-wrapper">
                    <div class="text-wrapper">
                      <span class="name">{{ stock.name }}</span>
                      <span class="value">{{ stock.value }}</span>
                    </div>
                    <div>
                      <p-progressBar
                        class="custom-progressBar"
                        [value]="stock.percentage"
                        [showValue]="false"
                      />
                    </div>
                  </div>
                </div>
              }
            }
            <div class="d-flex justify-content-end align-items-center mt-3 gap-2">
              <p-toggleSwitch
                [(ngModel)]="withAramco"
                (onChange)="changeAramcoData()"
                ariaLabel="Toggle Aramco data"
              />
              <p-avatar shape="circle">
                <img [src]="aramcoData()?.image" [alt]="aramcoData()?.name" />
              </p-avatar>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile: Swiper (hidden on larger screens) -->
      <swiper-container
        class="mobile-swiper"
        [dir]="isRtl() ? 'rtl' : 'ltr'"
        space-between="10"
        slides-per-view="1.1"
        pagination="true"
        pagination-clickable="true"
        grab-cursor="true"
        loop="false"
      >
        <swiper-slide>
          <div class="content">
            <h5 class="header-title">
              {{ 'home.bar-chart-1' | translate }}
              <mohlel-info-tooltip
                class="mx-2"
                [content]="'home.bar-chart-tooltip-eps' | translate"
                [metricName]="'eps'"
              />
            </h5>
            @if (isLoadingStatisticsChart()) {
              <p-skeleton height="400px" width="100%" />
            } @else {
              @for (stock of stocksEps; track stock.id) {
                <div class="stock-item" (click)="navigateToStock(stock.id)">
                  <p-avatar shape="circle">
                    <img [src]="stock.imageUrl" [alt]="stock.name" />
                  </p-avatar>

                  <div class="content-wrapper">
                    <div class="text-wrapper">
                      <span class="name">{{ stock.name }}</span>
                      <span class="value">{{ stock.value }}</span>
                    </div>
                    <div>
                      <p-progressBar
                        class="custom-progressBar"
                        [value]="stock.percentage"
                        [showValue]="false"
                      />
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="content">
            <h5 class="header-title">
              {{ 'home.bar-chart-2' | translate }}
              <mohlel-info-tooltip
                class="mx-2"
                [content]="'home.bar-chart-tooltip-pe' | translate"
                [metricName]="'trailing_pe'"
              />
            </h5>
            @if (isLoadingStatisticsChart()) {
              <p-skeleton height="400px" width="100%" />
            } @else {
              @for (stock of stocksTrailingPe; track stock.id) {
                <div class="stock-item" (click)="navigateToStock(stock.id)">
                  <p-avatar shape="circle">
                    <img [src]="stock.imageUrl" [alt]="stock.name" />
                  </p-avatar>

                  <div class="content-wrapper">
                    <div class="text-wrapper">
                      <span class="name">{{ stock.name }}</span>
                      <span class="value">{{ stock.value }}</span>
                    </div>
                    <div>
                      <p-progressBar
                        class="custom-progressBar"
                        [value]="stock.percentage"
                        [showValue]="false"
                      />
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="content">
            <h5 class="header-title">
              {{ 'home.bar-chart-3' | translate }}
              <mohlel-info-tooltip
                class="mx-2"
                [content]="'home.bar-chart-tooltip-market-cap' | translate"
                [metricName]="'market_cap'"
              />
            </h5>
            @if (isLoadingStatisticsChart()) {
              <p-skeleton height="400px" width="100%" />
            } @else {
              @for (stock of stocksMarketCap; track stock.id) {
                <div class="stock-item" (click)="navigateToStock(stock.id)">
                  <p-avatar shape="circle">
                    <img [src]="stock.imageUrl" [alt]="stock.name" />
                  </p-avatar>

                  <div class="content-wrapper">
                    <div class="text-wrapper">
                      <span class="name">{{ stock.name }}</span>
                      <span class="value">{{ stock.value }}</span>
                    </div>
                    <div>
                      <p-progressBar
                        class="custom-progressBar"
                        [value]="stock.percentage"
                        [showValue]="false"
                      />
                    </div>
                  </div>
                </div>
              }
            }
            <div class="d-flex justify-content-end align-items-center my-3 gap-2">
              <p-toggleSwitch
                [(ngModel)]="withAramco"
                (onChange)="changeAramcoData()"
                ariaLabel="Toggle Aramco data"
              />
              <p-avatar shape="circle">
                <img [src]="aramcoData()?.image" [alt]="aramcoData()?.name" />
              </p-avatar>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
  <div class="col-lg-4 col-md-12 col-sm-12">
    <div class="content">
      <div class="header">
        <h5 class="header-title">{{ 'home.market-statistics' | translate }}</h5>
      </div>
      <div class="body">
        <div class="row stock-details-wrapper">
          @if (isLoadingStatistics()) {
            <p-skeleton height="400px" width="100%" />
          } @else {
            @for (property of marketStatistics.properties; track property.id) {
              @if (
                property.normalizedKey !== NORMALIZED_KEY_SECTOR_COUNT &&
                property.normalizedKey !== NORMALIZED_KEY_STOCK_COUNT
              ) {
                <div class="col-lg-12 col-md-6">
                  <div class="stock-details">
                    <span class="key">
                      {{ property.name }}
                    </span>
                    <span class="value" dir="auto">
                      @if (property.dataType === 'Lookup') {
                        <span class="number-stat">{{ property.value?.name }}</span>
                      } @else {
                        <span
                          class="number-stat"
                          [class.negative]="property.isPositive === false"
                          >{{ property.value }}</span
                        >
                      }
                    </span>
                  </div>
                </div>
              }
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row top-low-section pt-3 g-3">
  @if (!isMobile()) {
    <div class="col-lg-8 col-md-12 col-sm-12">
      <div class="heatmap-chart-wrapper">
        <div class="header">
          <h5 class="header-title m-0">{{ 'home.heatmap-title' | translate }}</h5>
          <!-- <i
            [pTooltip]="'home.heatmap-tooltip-based-market-cap' | translate"
            [tooltipOptions]="{ tooltipPosition: 'top', tooltipStyleClass: 'info-tooltip' }"
            class="pi pi-info-circle"
            aria-hidden="true"
          >
          </i> -->
        </div>
        @if (isLoadingHeatmapChart()) {
          <p-skeleton height="500px" width="100%" />
        } @else {
          <mohlel-heatmap-chart [dataSource]="heatmapData()" [gradientRanges]="gradientRanges()" />
        }
      </div>
    </div>
  }
  <div class="col-lg-4 col-md-12 col-sm-12">
    <div class="d-flex flex-column gap-3 h-100">
      <mohlel-profit-loss-tabs
        [title]="'home.top-low-companies' | translate"
        [data]="stocksProfitLoss()"
        [showAvatar]="true"
        [showSymbol]="true"
        class="h-100"
      />
    </div>
  </div>
</div>

@if (upcomingEvents().length > 0) {
  <div class="upcoming-events">
    <a [routerLink]="['/calendar']" class="header-title">
      <h5 class="mb-0">
        {{ 'home.upcoming-events' | translate }}
      </h5>
      @if (isRtl()) {
        <i class="pi pi-chevron-left" aria-hidden="true"></i>
      } @else {
        <i class="pi pi-chevron-right" aria-hidden="true"></i>
      }
    </a>
    <div class="upcoming-events-list">
      <div class="row g-3">
        @if (isLoadingUpcomingEvents()) {
          @for (i of [].constructor(12); track $index) {
            <div class="col-lg-3 col-md-6 col-sm-12">
              <p-skeleton height="13rem" width="100%" />
            </div>
          }
        } @else {
          @for (event of upcomingEvents(); track event.id) {
            <div class="col-lg-3 col-md-6 col-sm-12">
              <mohlel-event-card [eventData]="event" />
            </div>
          }
        }
      </div>
    </div>
  </div>
}

<div class="sectors-section">
  <a [routerLink]="['/sectors']" class="header-title">
    <h5 class="mb-0">
      {{ 'home.sectors' | translate }}
    </h5>
    @if (isRtl()) {
      <i class="pi pi-chevron-left" aria-hidden="true"></i>
    } @else {
      <i class="pi pi-chevron-right" aria-hidden="true"></i>
    }
  </a>

  <!-- Mobile: Heatmap-style colored boxes using heatmapData() -->
  <div class="mobile-sectors">
    @if (isLoadingHeatmapChart()) {
      <div class="mobile-heatmap-grid">
        @for (i of [].constructor(9); track $index) {
          <p-skeleton height="90px" borderRadius="12px" />
        }
      </div>
    } @else {
      <div class="mobile-heatmap-grid">
        @for (sector of heatmapData(); track sector.id) {
          <div
            class="mobile-heatmap-box"
            [style.background-color]="getMobileSectorColor(sector.changePercentage)"
            (click)="navigateToSector(sector.id)"
          >
            <span class="mobile-heatmap-name">{{ sector.name }}</span>
            <span class="mobile-heatmap-change" dir="ltr">
              {{ sector.change }}
              ({{ sector.changePercentage }}%)
            </span>
          </div>
        }
      </div>
    }
  </div>

  <!-- Desktop: Show all sectors in grid -->
  <div class="desktop-sectors">
    <div class="desktop-grid">
      @for (sector of sectors; track sector.id) {
        <div (click)="navigateToSector(sector.id)" class="sector-card desktop-card">
          <div class="card-top">
            <span class="number">{{ sector.stocksCount }}</span>
            @if (isRtl()) {
              <i class="pi pi-chevron-left nav-arrow" aria-hidden="true"></i>
            } @else {
              <i class="pi pi-chevron-right nav-arrow" aria-hidden="true"></i>
            }
          </div>
          <span class="name">{{ sector.name }}</span>
        </div>
      }
    </div>
  </div>
</div>
